var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main-header" } }, [
    _c(
      "nav",
      { staticClass: "navbar navbar-default no-margin app-sidebar-nav" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "user-info" }, [
          _c("div", { staticClass: "user-info-container" }, [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary dropdown-toggle",
                  attrs: { type: "button", "data-toggle": "dropdown" }
                },
                [
                  _c("div", { staticClass: "dropdown-user" }, [
                    _c("div", { staticClass: "username-letter" }, [
                      _vm._v(_vm._s(_vm.iconLetters))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-user-right" }, [
                      _c("div", { staticClass: "username" }, [
                        _vm._v(
                          _vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName)
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "usermailid" }, [
                        _vm._v(_vm._s(_vm.username))
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout()
                      }
                    }
                  },
                  [_vm._v("Logout")]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "navbar-header fixed-brand" }, [
      _c(
        "button",
        {
          staticClass: "navbar-toggle collapsed",
          attrs: {
            type: "button",
            "data-toggle": "collapse",
            id: "menu-toggle"
          }
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-th-large",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "navbar-brand", attrs: { href: "javascript:void(0)" } },
        [
          _c("img", {
            attrs: {
              src: "/static/images/logo.png",
              alt: "Velocity Vehicle Group"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "collapse navbar-collapse",
        attrs: { id: "bs-example-navbar-collapse-1" }
      },
      [
        _c("ul", { staticClass: "nav navbar-nav" }, [
          _c("li", { staticClass: "active" }, [
            _c(
              "button",
              {
                staticClass: "navbar-toggle collapse in",
                attrs: { "data-toggle": "collapse", id: "menu-toggle-2" }
              },
              [
                _c("img", {
                  staticClass: "menubar",
                  attrs: { src: "/static/images/menubar.png", alt: "Menu" }
                })
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5fdd6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5fdd6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = null
// module chunks = 